export class PasswordUpdateRequest {
    password: string;
    passwordResetToken: string;
}
